import api from "./index";

export const dashAPi = {
    postSalvarParametros: async (data, token) => {
        var result = await api.post("/Dash/SalvarParametros", data, token);
        return result;
    }
}